/* Verbiva temos priekis v3 (2026-10-22): galerija, paketai, į krepšelį, lipnus mygtukas, skirtukai, pristatymo data,
   atsiradimas, antraščių žodžiai, skaičių skaičiavimas, 12 sav. linija. Be bibliotekų. ?vbqa=1 — be animacijų (ekrano kopijoms). */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  root.classList.add('vb-js');
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  var qa = /[?&]vbqa=1/.test(location.search);
  var reduce = qa || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var hasIO = 'IntersectionObserver' in window;

  /* Galerija */
  $$('[data-vb-gal]').forEach(function (g) {
    var track = $('.vb-gal__track', g), slides = $$('.vb-gal__slide', g), dots = $$('.vb-gal__dots button', g), thumbs = $$('.vb-gal__thumbs button', g);
    if (!track) return;
    function idx() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function go(i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
    function mark() {
      var i = idx();
      dots.forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
      thumbs.forEach(function (b, k) { b.classList.toggle('is-on', k === i); if (k === i && b.scrollIntoView && b.parentNode.scrollWidth > b.parentNode.clientWidth) { b.parentNode.scrollTo({ left: b.offsetLeft - b.parentNode.clientWidth / 2 + b.clientWidth / 2, behavior: 'smooth' }); } });
    }
    var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(mark, 60); }, { passive: true });
    dots.forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
    thumbs.forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
    var p = $('.vb-gal__arrow--prev', g), n = $('.vb-gal__arrow--next', g);
    if (p) p.addEventListener('click', function () { go(idx() - 1); });
    if (n) n.addEventListener('click', function () { go(idx() + 1); });
    mark();
  });

  /* Paketai + į krepšelį (v7, 2026-10-22): tikri vienetai. Plytelė = N apmokamų + N nemokamų to paties butelio;
     nemokamus nuskaičiuoja Shopify „Buy N, Get N Free“ nuolaidos. Prenumerata (Seal planas): apmokami su selling_plan,
     nemokami — vienkartiniai (Shopify BXGY taisyklė). Į krepšelį = senos butelių eilutės pakeičiamos nauju paketu. */
  $$('[data-vb-buy]').forEach(function (box) {
    var form = $('form', box), btn = $('[data-vb-atc]', box), label = $('[data-vb-atc-price]', box);
    var sticky = $('[data-vb-sticky]', box), sPrice = sticky && $('[data-vb-sticky-price]', sticky), sTitle = sticky && $('[data-vb-sticky-title]', sticky);
    var idEl = $('input[name="id"]', box), vid = idEl ? parseInt(idEl.value, 10) : 0;
    var sub = $('[data-vb-sub]', box), subT = sub && $('[data-vb-sub-toggle]', sub), note = $('[data-vb-sub-note]', box), pv = $('[data-vb-sub-preview]', box);
    var plan = sub ? sub.getAttribute('data-plan') : '';
    if (window.VBBundle && sub) { if (plan) window.VBBundle.p1 = plan; if (sub.getAttribute('data-plan2')) window.VBBundle.bp = sub.getAttribute('data-plan2'); }
    var live = !!(window.Shopify && Shopify.theme && Shopify.theme.role === 'main');
    if (sub && !plan && !live) { sub.hidden = false; if (pv) pv.hidden = false; }
    function isSub() { return !!(subT && subT.checked && !sub.hidden); }
    function cur() { return $('input[name="quantity"]:checked', box) || $('input[name="quantity"]', box); }
    function bottles(n) { return n + (n === 1 ? ' bottle' : ' bottles'); }
    function sync() {
      var c = cur(); if (!c) return;
      var s = isSub(), price = c.getAttribute(s ? 'data-ps' : 'data-po');
      box.classList.toggle('is-sub', s);
      if (label) label.textContent = price;
      if (sPrice) sPrice.textContent = price;
      if (sTitle) sTitle.textContent = c.getAttribute('data-title');
      if (note) {
        var pd = parseInt(c.getAttribute('data-paid'), 10) || 1, fr = parseInt(c.getAttribute('data-free'), 10) || 0;
        var t = fr > 0 ? note.getAttribute('data-t-free') : note.getAttribute('data-t-one');
        note.hidden = !s || !t;
        if (s && t) note.innerHTML = t.replace('{total}', '<b>' + bottles(pd + fr) + '</b>').replace('{free}', fr + ' free').replace('{paid}', '<b>' + bottles(pd) + '</b>').replace('{price}', '<b>' + price + '</b>');
      }
    }
    $$('input[name="quantity"]', box).forEach(function (r) { r.addEventListener('change', sync); });
    if (subT) subT.addEventListener('change', sync);
    if (!$('input[name="quantity"]:checked', box) && cur()) cur().checked = true;
    sync();
    function add() {
      var c = cur(); if (!c || !btn || !vid || !window.VBBundle) { if (form) form.submit(); return; }
      btn.setAttribute('aria-busy', 'true');
      var pd = parseInt(c.getAttribute('data-paid'), 10) || 1, fr = parseInt(c.getAttribute('data-free'), 10) || 0;
      window.VBBundle.set(vid, pd, fr, isSub() && plan ? plan : null)
        .then(function () { btn.removeAttribute('aria-busy'); if (window.VPCart) window.VPCart.open(true); else location.href = '/cart'; })
        .catch(function () { btn.removeAttribute('aria-busy'); if (form) form.submit(); });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
    if (sticky && btn) {
      var sb = $('[data-vb-sticky-btn]', sticky);
      if (sb) sb.addEventListener('click', function () { add(); });
      var tick = false;
      function chk() { tick = false; var r = btn.getBoundingClientRect(); sticky.classList.toggle('is-on', r.bottom < 0); }
      window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(chk); } }, { passive: true });
      chk();
    }
  });

  /* „What parents report“ be apklausos skaičių: gyvai paslėpta (CSS), neskelbtos temos peržiūroje — rodoma su priminimu */
  if (!(window.Shopify && Shopify.theme && Shopify.theme.role === 'main')) $$('[data-vb-pending]').forEach(function (el) { el.classList.add('is-pv'); });

  /* Pristatymo data: šiandien + min…max darbo dienų (angliškai) */
  function addBiz(dt, n, cal) { var x = new Date(dt); if (cal) { x.setDate(x.getDate() + n); return x; } while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; }
  $$('[data-vb-eta]').forEach(function (el) {
    var mn = parseInt(el.getAttribute('data-min') || '7', 10), mx = parseInt(el.getAttribute('data-max') || '12', 10), now = new Date();
    var f = function (x) { return x.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
    var cal = el.getAttribute('data-biz') === '0';
    el.innerHTML = el.getAttribute('data-template').replace('{from}', '<b>' + f(addBiz(now, mn, cal)) + '</b>').replace('{to}', '<b>' + f(addBiz(now, mx, cal)) + '</b>');
  });

  /* Skirtukai */
  $$('[data-vb-tabs]').forEach(function (w) {
    var bs = $$('[data-tab]', w), ps = $$('[data-panel]', w);
    bs.forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-tab');
        bs.forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
        ps.forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-panel') === k); });
      });
    });
  });

  /* Antraštės: žodis po žodžio */
  function splitWords(h) {
    var i = 0, nodes = Array.prototype.slice.call(h.childNodes);
    h.textContent = '';
    nodes.forEach(function (n) {
      if (n.nodeType === 3) {
        n.textContent.split(/(\s+)/).forEach(function (part) {
          if (!part) return;
          if (/^\s+$/.test(part)) { h.appendChild(d.createTextNode(' ')); return; }
          var w = d.createElement('span'), s = d.createElement('span'); w.className = 'vb-w'; s.textContent = part; s.style.setProperty('--i', i++); w.appendChild(s); h.appendChild(w);
        });
      } else if (n.nodeType === 1) {
        n.textContent.split(/(\s+)/).forEach(function (part) {
          if (!part) return;
          if (/^\s+$/.test(part)) { h.appendChild(d.createTextNode(' ')); return; }
          var w2 = d.createElement('span'), s2 = d.createElement('span'), c = n.cloneNode(false); c.textContent = part;
          w2.className = 'vb-w'; s2.style.setProperty('--i', i++); s2.appendChild(c); w2.appendChild(s2); h.appendChild(w2);
        });
      }
    });
    h.classList.add('vb-wd');
  }

  /* Skaičiai: suskaičiuoja nuo 0 */
  function countUp(el) {
    var to = parseFloat(el.getAttribute('data-vb-count')), dec = (el.getAttribute('data-vb-count').split('.')[1] || '').length, t0 = null, dur = 1400;
    function step(ts) { if (!t0) t0 = ts; var k = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - k, 3); el.textContent = (to * e).toFixed(dec); if (k < 1) requestAnimationFrame(step); }
    el.textContent = (0).toFixed(dec); requestAnimationFrame(step);
  }

  if (!reduce && hasIO) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        el.classList.add('is-in');
        if (el.hasAttribute('data-vb-count')) countUp(el);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    $$('.vb-sec .vb-h2, .vb-row h3').forEach(function (h) { splitWords(h); io.observe(h); });
    $$('.vb-bstat, .vb-row__img, .vb-row__b, .vb-q, .vb-lab__it, .vb-jr2__s, .vb-cmp, .vb-guar2, .vb-faq details, .vb-help, .vb-sci2__fig, .vb-bento__img, .vb-lab__img, .vb-lead, .vb-eyebrow, .vb-ring, .vb-why, .vb-revs__vp, .vb-ben__img, .vb-ben__r, .vb-wk__s, .vb-std').forEach(function (el, i) {
      el.classList.add('vb-rv'); el.style.transitionDelay = (i % 4) * 70 + 'ms'; io.observe(el);
    });
    $$('[data-vb-count]').forEach(function (el) { io.observe(el); });
  }

  /* 12 sav. linija pildosi slenkant */
  $$('[data-vb-line]').forEach(function (w) {
    var line = $('.vb-jr2__line, .vb-wk__line', w), steps = $$('.vb-jr2__s, .vb-wk__s', w);
    if (!line) return;
    function upd() {
      var lr = line.getBoundingClientRect(), vh = window.innerHeight, horiz = lr.width > lr.height, p;
      if (qa || reduce) p = 1;
      else if (horiz) { var wr = w.getBoundingClientRect(); p = Math.min(1, Math.max(0, (vh * 0.72 - wr.top) / (vh * 0.45))); }
      else p = Math.min(1, Math.max(0, (vh * 0.62 - lr.top) / Math.max(1, lr.height)));
      w.style.setProperty('--p', p.toFixed(3));
      steps.forEach(function (s) {
        var dot = $('.vb-jr2__dot, .vb-wk__dot', s), dr = dot.getBoundingClientRect();
        var f = horiz ? (dr.left + dr.width / 2 - lr.left) / Math.max(1, lr.width) : (dr.top + dr.height / 2 - lr.top) / Math.max(1, lr.height);
        s.classList.toggle('is-lit', p >= f - 0.02);
      });
    }
    var tk = false;
    window.addEventListener('scroll', function () { if (!tk) { tk = true; requestAnimationFrame(function () { tk = false; upd(); }); } }, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  });

  /* Atsiliepimai: rodyklės + video (paspaudus groja su garsu, kiti sustoja) */
  $$('[data-vb-revs]').forEach(function (w) {
    var tr = $('[data-vb-revs-track]', w); if (!tr) return;
    function step() { var c = $('.vb-revs__c', tr); return c ? c.getBoundingClientRect().width + 16 : 300; }
    var pv = $('[data-vb-revs-prev]', w), nx = $('[data-vb-revs-next]', w);
    if (pv) pv.addEventListener('click', function () { tr.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (nx) nx.addEventListener('click', function () { tr.scrollBy({ left: step(), behavior: 'smooth' }); });
    function nav() { var max = tr.scrollWidth - tr.clientWidth - 2; w.classList.toggle('is-static', max <= 0); if (pv) pv.disabled = tr.scrollLeft <= 2; if (nx) nx.disabled = tr.scrollLeft >= max; }
    tr.addEventListener('scroll', function () { requestAnimationFrame(nav); }, { passive: true }); window.addEventListener('resize', nav); nav();
    $$('.vb-revs__m', tr).forEach(function (m) {
      var v = $('video', m), b = $('[data-vb-play]', m); if (!v) return;
      function toggle() {
        if (v.paused) { $$('video', tr).forEach(function (o) { if (o !== v) { o.pause(); o.parentNode.classList.remove('is-playing'); } }); v.muted = false; v.play(); m.classList.add('is-playing'); }
        else { v.pause(); m.classList.remove('is-playing'); }
      }
      m.addEventListener('click', toggle);
      v.addEventListener('ended', function () { m.classList.remove('is-playing'); });
    });
  });

  /* Savaitės: telefone išskleidžiamos (kompaktiškiau) */
  $$('[data-vb-wk-toggle]').forEach(function (h) {
    function t() { if (window.innerWidth >= 600) return; var s = h.closest('.vb-wk__s'); s.classList.toggle('is-open'); h.setAttribute('aria-expanded', s.classList.contains('is-open')); }
    h.addEventListener('click', t);
    h.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); t(); } });
  });

  /* Meniu: uždaryti paspaudus nuorodą */
  $$('.vb-menu').forEach(function (m) {
    var hdr = m.closest('.vb-hdr');
    m.addEventListener('toggle', function () { if (hdr) hdr.classList.toggle('is-menu', m.open); root.classList.toggle('vb-lock', m.open); });
    $$('a', m).forEach(function (a) { a.addEventListener('click', function () { m.open = false; }); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && m.open) m.open = false; });
    m.addEventListener('click', function (e) { if (e.target === m) m.open = false; });
  });
})();

/* Paketas krepšelyje (v7, 2026-10-22): VBBundle.set(variantas, apmokami, nemokami, planas) — ištrina visas butelio eilutes
   ir įdeda paketą iš naujo (Shopify išskaido eilutes pagal nuolaidą, todėl jų kiekio tiesiogiai keisti negalima). */
window.VBBundle = {
  set: function (vid, paid, free, plan) {
    var J = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    /* v8: paketas su prenumerata → visi vienetai „free bottles“ plane (bp), kad kitą mėnesį išeitų tiek pat butelių už tą pačią sumą; 1 butelis → p1 */
    var bd = (window.VPCart && window.VPCart.data && window.VPCart.data.bundle) || {}, P1 = String(this.p1 || bd.p1 || ''), BP = String(this.bp || bd.bp || '');
    if (P1 === '0') P1 = ''; if (BP === '0') BP = '';
    var useBP = false;
    if (plan && BP) { if (free > 0) { plan = BP; useBP = true; } else if (String(plan) === BP) plan = P1 || null; }
    function cart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
    return cart().then(function (c) {
      var upd = {}, n = 0;
      c.items.forEach(function (it) { if (it.variant_id === vid) { upd[it.key] = 0; n++; } });
      return n ? fetch('/cart/update.js', { method: 'POST', headers: J, body: JSON.stringify({ updates: upd }) }).then(function (r) { if (!r.ok) throw r; }) : null;
    }).then(function () {
      if (!(paid > 0)) return cart();
      var items = useBP ? [{ id: vid, quantity: paid + free, selling_plan: parseInt(plan, 10) }]
        : plan ? [{ id: vid, quantity: paid, selling_plan: parseInt(plan, 10) }] : [{ id: vid, quantity: paid + (free || 0) }];
      if (plan && free > 0 && !useBP) items.push({ id: vid, quantity: free });
      return fetch('/cart/add.js', { method: 'POST', headers: J, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw r; return cart(); });
    });
  }
};

/* Krepšelio stalčius v7: butelio eilutės rodomos kaip dvi — apmokama (su +/−, prenumeratos žyma) ir nemokama (žyma pagal nuolaidą).
   Kabliukai vbIsMain / vbTier / vbRows / vbBind kviečiami iš vp.js render. Dovanos eilutė perjungia į tos pakopos paketą. */
(function () {
  'use strict';
  var VP = window.VPCart, dr = document.getElementById('vp-cart');
  if (!VP || !dr) return;
  function B() { return (VP.data || {}).bundle || null; }
  function T(k, f) { var t = (VP.data || {}).t || {}; return t[k] || f; }
  function all(s) { return Array.prototype.slice.call(dr.querySelectorAll(s)); }
  function money(c) { var k = VP.data || {}; try { return new Intl.NumberFormat(k.locale || 'en', { style: 'currency', currency: k.currency || 'USD' }).format(c / 100); } catch (e) { return (c / 100).toFixed(2); } }
  function esc(x) { return String(x || '').replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  function r5(x) { return Math.round(x / 5) * 5; }
  var TIERS = [[1, 0], [1, 1], [2, 2], [3, 3]];
  function tierIdx(st) { for (var i = TIERS.length - 1; i >= 0; i--) if (st.P === TIERS[i][0] && st.F === TIERS[i][1]) return i; var u = st.P + st.F, k = -1; TIERS.forEach(function (t, i) { if (u >= t[0] + t[1]) k = i; }); return k; }
  function units(cart) { var b = B(), u = 0; if (b) cart.items.forEach(function (it) { if (it.variant_id === b.v) u += it.quantity; }); return u; }
  function state(cart) {
    var b = B(), st = { P: 0, F: 0, paid: 0, paidWas: 0, freeWas: 0, plan: null, tag: '', img: '', title: '' };
    if (!b) return st;
    cart.items.forEach(function (it) {
      if (it.variant_id !== b.v) return;
      var sp0 = it.selling_plan_allocation;
      if (sp0 && b.bp && String(sp0.selling_plan.id) === String(b.bp)) {
        var fq = Math.floor(it.quantity / 2), pq = it.quantity - fq;
        st.P += pq; st.F += fq; st.paid += it.final_line_price; st.paidWas += b.unit * pq; st.freeWas += b.unit * fq; st.plan = sp0; st.bp = true;
        if (!st.img) st.img = b.img || (it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : '');
        if (!st.title) st.title = it.product_title;
        return;
      }
      var unitO = it.quantity ? it.original_line_price / it.quantity : 0, best = null, disc = 0;
      (it.line_level_discount_allocations || []).forEach(function (a) { disc += a.amount; if (a.amount > 0 && (!best || a.amount > best.amount)) best = a; });
      var fu = unitO ? Math.min(it.quantity, Math.round(disc / unitO)) : 0, pu = it.quantity - fu;
      st.F += fu; st.P += pu; st.paid += it.final_line_price; st.freeWas += unitO * fu;
      var spa = it.selling_plan_allocation;
      st.paidWas += (spa ? (b.unit || spa.compare_at_price) : unitO) * pu;  /* update.js atsakyme plano kainos apvalintos (2800/4000) — imam butelio kainą */
      if (spa && pu > 0) st.plan = spa;
      if (best && !st.tag) st.tag = String(best.discount_application.title || '').split(' + ')[0];
      if (!st.img) st.img = b.img || (it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : '');
      if (!st.title) st.title = it.product_title;
    });
    if (st.bp && st.F > 0) st.tag = 'Buy ' + st.P + ', Get ' + st.F + ' Free';
    return st;
  }
  VP.vbIsMain = function (it) { var b = B(); return !!b && it.variant_id === b.v; };
  VP.vbTier = function (cart) { var b = B(), u = units(cart), t = 0; if (!b) return 0; (b.tierUnits || [1, 2, 4, 6]).forEach(function (n, i) { if (u >= n) t = i + 1; }); return t; };
  VP.vbRows = function (cart) {
    var b = B(), st = state(cart), html = '', icon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg>';
    VP._vb = st;
    if (!b || !(st.P + st.F)) return { html: '', was: 0, tier: 0 };
    var img = '<img src="' + esc(st.img) + '" alt="" width="72" height="72" loading="lazy">';
    if (st.P > 0) {
      var subl = '';
      if (st.plan) { var pct = st.bp ? (st.paidWas ? r5((st.paidWas - st.paid) * 100 / st.paidWas) : 0) : st.plan.compare_at_price ? r5((st.plan.compare_at_price - st.plan.price) * 100 / st.plan.compare_at_price) : 0; subl = '<span class="vpc-sub vb-ci__sub"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 11a8 8 0 0 0-14.3-4.9L4 8"/><path d="M4 4v4h4"/><path d="M4 13a8 8 0 0 0 14.3 4.9L20 16"/><path d="M20 20v-4h-4"/></svg>' + esc(T('sub_line', 'Delivered every month · {pct}% off').replace('{pct}', pct)) + '</span>'; }
      html += '<li class="vpc-item vb-ci">' + img + '<div class="vpc-item__main"><b>' + esc(st.title) + '</b>' + subl +
        '<div class="vpc-qty"><button type="button" data-vb-step="-1" aria-label="−">−</button><span>' + st.P + '</span><button type="button" data-vb-step="1" aria-label="+"' + (tierIdx(st) >= TIERS.length - 1 ? ' disabled' : '') + '>+</button></div></div>' +
        '<div class="vpc-item__price">' + (st.paidWas > st.paid ? '<s>' + money(st.paidWas) + '</s>' : '') + money(st.paid) +
        '<button type="button" class="vpc-remove" data-vb-step="0">' + esc(T('remove', 'Remove')) + '</button></div></li>';
    }
    if (st.F > 0) {
      html += '<li class="vpc-item vb-ci vb-ci--free">' + img + '<div class="vpc-item__main"><b>' + esc(st.title) + '</b>' +
        '<span class="vb-ci__tag">' + icon + esc(st.tag || T('free_tag', 'Free bottles')) + '</span>' +
        '<span class="vb-ci__q">' + esc(T('free_qty', 'Qty {n}').replace('{n}', st.F)) + (st.bp ? ' · ' + esc(T('free_every', 'included every month')) : st.plan ? ' · ' + esc(T('free_first', 'ships with your first order')) : '') + '</span></div>' +
        '<div class="vpc-item__price"><s>' + money(st.freeWas) + '</s><b class="vb-ci__free">' + esc(T('gift', 'Free')) + '</b></div></li>';
    }
    return { html: html, was: Math.max(st.paidWas, st.paid) + st.freeWas, tier: VP.vbTier(cart) };
  };
  function go(P, F, plan, el) {
    var b = B(); if (!b) return;
    if (el) el.setAttribute('aria-busy', 'true');
    dr.classList.add('is-busy');
    window.VBBundle.set(b.v, P, F, plan).then(function (c) { dr.classList.remove('is-busy'); VP.render(c); }, function () { dr.classList.remove('is-busy'); VP.refresh(); });
  }
  VP.vbBind = function (list) {
    Array.prototype.slice.call(list.querySelectorAll('[data-vb-step]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        /* +/− eina paketais: 1 → 1+1 → 2+2 → 3+3 (ne po vieną butelį) */
        var st = VP._vb || { P: 0, F: 0 }, step = parseInt(btn.getAttribute('data-vb-step'), 10), j = step === 0 ? -1 : Math.min(TIERS.length - 1, tierIdx(st) + step);
        var t = j < 0 ? [0, 0] : TIERS[j];
        go(t[0], t[1], st.plan ? st.plan.selling_plan.id : null, btn);
      });
    });
  };
  /* Dovanos eilutė: tos pakopos paketas (pvz. 3+3), mygtuke — kainų skirtumas */
  function paint(cart) {
    var b = B(); if (!b) return;
    var st = state(cart), unit = st.plan ? st.plan.price : b.unit;
    all('[data-vb-gift-variant]').forEach(function (g) {
      var on = g.classList.contains('is-on'), cta = g.querySelector('[data-vb-gift-cta]'); if (!cta) return;
      var t = TIERS[(parseInt(g.getAttribute('data-vp-gift-tier'), 10) || 4) - 1] || TIERS[3], diff = (st.plan && b.bpPrice ? b.bpPrice * (t[0] + t[1]) : unit * t[0]) - st.paid;
      cta.innerHTML = on ? (g.getAttribute('data-done') || '✓') : g.getAttribute('data-cta') + (st.P + st.F && diff > 0 ? ' <small>+' + money(diff) + '</small>' : '');
      g.classList.toggle('is-done', on);
      g.setAttribute('aria-disabled', on ? 'true' : 'false');
    });
  }
  var orig = VP.render;
  VP.render = function (cart) { var r = orig.apply(this, arguments); try { if (cart && cart.items) paint(cart); } catch (e) {} return r; };
  function pick(g) {
    if (g.classList.contains('is-on') || g.getAttribute('aria-busy')) return;
    var t = TIERS[(parseInt(g.getAttribute('data-vp-gift-tier'), 10) || 4) - 1] || TIERS[3], st = VP._vb || {};
    go(t[0], t[1], st.plan ? st.plan.selling_plan.id : null, g);
  }
  dr.addEventListener('click', function (e) { var g = e.target.closest && e.target.closest('[data-vb-gift-variant]'); if (g) pick(g); });
  dr.addEventListener('keydown', function (e) {
    var g = e.target.closest && e.target.closest('[data-vb-gift-variant]');
    if (g && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); pick(g); }
  });
})();
